import React from 'react'
import { Route } from 'react-router-dom'
import MainClientManagement from '../Views/Web/Client Management/MainClientManagement'
import { IndexSurveyReport, SurveyReportCreate, SurveyReportEdit, SurveyReportMain, SurveyReportsView, ViewForm, Equipments, OpenForm, DummyForms } from '../Views/Web/Client Management/SurveyReport'
import { ContractsCreate, ContractsEdit, ContractsMain, ContractsView, EquipmentsContract, FormContract, IndexContract, InspectionContract, InvoiceContract, ServiceContract } from '../Views/Web/Client Management/Contracts'
import { IndexRenewal, RenewalCreate, RenewalEdit, RenewalMain, RenewalView } from '../Views/Web/Client Management/Renewal'
import MainContractManagement from '../Views/Web/Client Management/MainContractManagement'

function ContractManagement() {
  return (
     <Route path="Contract-management" element={<MainContractManagement />}>
          
         <Route path="survey-report" element={<SurveyReportMain/>} >
           <Route index element={<IndexSurveyReport/>} />   
           <Route path='create' element={<SurveyReportCreate/>} />
           <Route path='edit/:surveyReportEditId' element={<SurveyReportEdit/>} />
           <Route path='view/:surveyReportViewId' element={<SurveyReportsView/>} />
           <Route path='form/:surveyReportViewId' element={<ViewForm/>} />
           {/* <Route path='form/:surveyReportViewId' element={<DummyForms/>} /> */}

           {/* <Route path='formOpen/:surveyReportViewId' element={<OpenForm/>} />*/}

           <Route path='equipments/:surveyReportViewId' element={<Equipments/>} /> 

          </Route>
         
          <Route path="contracts" element={<ContractsMain/>} >
           <Route index element={<IndexContract/>} />
           <Route path='create' element={<ContractsCreate/>} />
           <Route path='edit/:contractsEditId' element={<ContractsEdit/>} />
           <Route path='view/:contractsViewId' element={<ContractsView/>} />
           <Route path='form/:contractsViewId' element={<FormContract/>} />
           <Route path='equipments/:contractsViewId' element={<EquipmentsContract/>} />
           <Route path='inspection/:contractsViewId' element={<InspectionContract/>} />
           <Route path='invoice/:contractsViewId' element={<InvoiceContract/>} />
           <Route path='service/:contractsViewId' element={<ServiceContract/>} />



          </Route>

          <Route path="renewal" element={<RenewalMain/>} >
           <Route index element={<IndexRenewal/>} />
           <Route path='create' element={<RenewalCreate/>} />
           <Route path='edit/:renewalEditId' element={<RenewalEdit/>} />
           <Route path='view/:renewalViewId' element={<RenewalView/>} />
          </Route>
          
      </Route>
  )
}

export default ContractManagement